import React from 'react';
import { Form, Input, Button, Space, Card, Checkbox, Select, Tooltip } from 'antd';
import { PlusOutlined, MinusCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const { TextArea } = Input;

/**
 * Kod tipleri için parametre şeması düzenleyici
 */
const ParameterSchemaEditor = ({ value = [], onChange }) => {
  const handleChange = (newList) => {
    if (onChange) {
      onChange(newList);
    }
  };

  return (
    <div className="parameter-schema-editor">
      <Form.List name="parameterSchema">
        {(fields, { add, remove }) => (
          <>
            {fields.length === 0 && (
              <div style={{ marginBottom: 16 }}>
                <em>Henüz parametre eklenmedi. Aşağıdaki butona tıklayarak parametre ekleyebilirsiniz.</em>
              </div>
            )}
            
            {fields.map(({ key, name, ...restField }) => (
              <Card 
                key={key} 
                size="small" 
                title={`Parametre #${name + 1}`}
                style={{ marginBottom: 16 }}
                extra={
                  <Tooltip title="Bu parametreyi sil">
                    <Button 
                      type="text" 
                      danger 
                      icon={<MinusCircleOutlined />} 
                      onClick={() => remove(name)} 
                    />
                  </Tooltip>
                }
              >
                <Space direction="vertical" style={{ width: '100%' }} size="small">
                  <Form.Item
                    {...restField}
                    name={[name, 'name']}
                    rules={[
                      { required: true, message: 'Parametre adı zorunludur' },
                      { 
                        pattern: /^[a-zA-Z0-9_]+$/, 
                        message: 'Parametre adı sadece harf, rakam ve alt çizgi içerebilir' 
                      }
                    ]}
                    label="Parametre Adı"
                    tooltip="Sistem içinde kullanılacak parametre adı"
                  >
                    <Input placeholder="Örn: trackingId" />
                  </Form.Item>
                  
                  <Form.Item
                    {...restField}
                    name={[name, 'label']}
                    rules={[{ required: true, message: 'Etiket zorunludur' }]}
                    label="Etiket"
                    tooltip="Kullanıcıya gösterilecek form etiketi"
                  >
                    <Input placeholder="Örn: Takip ID" />
                  </Form.Item>
                  
                  <Form.Item
                    {...restField}
                    name={[name, 'type']}
                    initialValue="text"
                    label="Tip"
                    tooltip="Parametre değerinin tipi"
                  >
                    <Select>
                      <Select.Option value="text">Metin</Select.Option>
                      <Select.Option value="number">Sayı</Select.Option>
                      <Select.Option value="password">Şifre</Select.Option>
                      <Select.Option value="textarea">Çok Satırlı Metin</Select.Option>
                      <Select.Option value="url">URL</Select.Option>
                      <Select.Option value="email">E-posta</Select.Option>
                    </Select>
                  </Form.Item>
                  
                  <Form.Item
                    {...restField}
                    name={[name, 'placeholder']}
                    label="Örnek"
                    tooltip="Form alanında gösterilecek örnek değer"
                  >
                    <Input placeholder="Örn: UA-XXXXXXXX-X" />
                  </Form.Item>
                  
                  <Form.Item
                    {...restField}
                    name={[name, 'description']}
                    label="Açıklama"
                    tooltip="Kullanıcıya gösterilecek açıklama metni"
                  >
                    <TextArea placeholder="Bu parametre ne işe yarar?" rows={2} />
                  </Form.Item>
                  
                  <Form.Item
                    {...restField}
                    name={[name, 'required']}
                    valuePropName="checked"
                    initialValue={true}
                    label={
                      <Space>
                        Zorunlu
                        <Tooltip title="Bu parametre zorunlu mu?">
                          <QuestionCircleOutlined />
                        </Tooltip>
                      </Space>
                    }
                  >
                    <Checkbox>Bu alan zorunludur</Checkbox>
                  </Form.Item>
                </Space>
              </Card>
            ))}
            
            <Form.Item>
              <Button 
                type="dashed" 
                onClick={() => add()} 
                block 
                icon={<PlusOutlined />}
              >
                Parametre Ekle
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </div>
  );
};

export default ParameterSchemaEditor; 